module.exports = new __parcel__URL__("blade-runner.35e26245.jpg").toString();